<template>
  <div>
    <el-dialog title="添加自行采购的交通产品" class="addBigTrafficDialog" :visible.sync="dialogVisible" width="60%" :show-close="false">
      <div class="bigTrafficAdd" v-for="(item,index) in dataList" :key="index">
        <div class="infoDiv">
          <p>
            <el-radio v-for="(item1,index1) in typeObj.radioList" :key="index1" :label="item1.value" @change="changeTrafficType(item,item1.name)" 
              v-model="item.trafficType">{{item1.name}}</el-radio>

              <el-button v-if="item.trafficType===1" type="text" style="position: relative;left: 0%;top: 0px;transform: scale(0.85);" @click="goXc(index)">前往携程>></el-button>

          </p>
          <div v-for="(item1,index1) in item.detailList" :key="index1">
            <p>
              <span class="itemNo">{{index1+1}}</span>
              <span>{{typeObj.stateProductLabel}}</span>
              <el-input placeholder="请输入航班号" style="width:2rem" size="small" v-model="item1.flightNumber"></el-input>
              <el-input placeholder="备注" style="width:5.2rem;margin-left: 0.15rem;" size="small" v-model="item1.remark"></el-input>
            </p>
            <p>
              <el-date-picker v-model="item1.startDate" type="date" value-format="yyyy-MM-dd" size="small" class="inputDiv" @change="startTimeChange"></el-date-picker>
              <el-time-picker v-model="item1.startTime" :default-value="index1>0?item.detailList[index1-1].endTimeDefalut:item1.startTimeDefalut" 
                @change="changeTime(item1,'startTimeDefalut','startDate','startTime')" value-format="HH:mm"
                placeholder="出发时间" class="inputDiv" size="small" format="HH:mm"></el-time-picker>
              <span>出发城市</span>
              <city-autocomplete :width="'width:1.8rem;margin-right:0.1rem'" :obj="item1" :placeholderText="''" :action="false"
                @handleSelect="handleSelect($event,'start',item1)" :sizeType="'small'"></city-autocomplete>
              <el-select v-model="item1.startPortName" filterable allow-create :placeholder="'出发'+typeObj.stateProtName" size="small" class="inputDiv">
                <el-option v-for="item in item1.startPortList" :key="item.id" :label="item.airportNameCn" :value="item.airportNameCn"></el-option>
              </el-select>
              <el-input v-if="typeObj.state==1" v-model="item1.startFlightNo" placeholder="填写航站楼" style="width:1rem" size="small"></el-input>
            </p>
            <p>
              <el-date-picker v-model="item1.endDate" type="date" value-format="yyyy-MM-dd" size="small" class="inputDiv" @change="endTimeChange"></el-date-picker>
              <el-time-picker v-model="item1.endTime" placeholder="抵达时间" :default-value="item1.startTimeDefalut" value-format="HH:mm"
                @change="changeTime(item1,'endTimeDefalut','endDate','endTime')" class="inputDiv" size="small" format="HH:mm"></el-time-picker>
              <span>抵达城市</span>
              <city-autocomplete :width="'width:1.8rem;margin-right:0.1rem'" :obj="item1" :placeholderText="''" :sizeType="'small'" 
                :idProName="'endCityId'" :nameProName="'endCityName'" :action="false" @handleSelect="handleSelect($event,'end',item1)"></city-autocomplete>
              <el-select v-model="item1.endPortName" filterable allow-create :placeholder="'抵达'+typeObj.stateProtName" size="small" class="inputDiv">
                <el-option v-for="item in item1.endPortList" :key="item.id" :label="item.airportNameCn" :value="item.airportNameCn"></el-option>
              </el-select>
              <el-input v-if="typeObj.state==1" v-model="item1.endFlightNo" placeholder="填写航站楼" style="width:1rem" size="small"></el-input>
            </p>
          </div>
        </div> 
        <div class="moneyDiv">
          <button v-if="item.trafficType==3" @click="addFight(item)">添加航班</button>
          <div class="moneySum"></div>
        </div>
        <div class="budgetDiv">
          <p v-for="(item1,index1) in item.budgetDetailList" :key="index1">
            <span>乘客类型</span>
            <el-select v-model="item1.passengerType" default-first-option placeholder="请选择" size="small" style="width:1rem" class="inputDiv">
              <el-option v-for="item2 in passengerOption" :key="item2" :label="item2" :value="item2"></el-option>
            </el-select>
            <span>{{typeObj.state==2?'座位':'舱位'+'等级'}}</span>
            <el-select v-model="item1.siteType" default-first-option placeholder="请选择" size="small" style="width:1.2rem" class="inputDiv">
              <el-option v-for="item2 in typeObj.siteStepList" :key="item2" :label="item2" :value="item2"></el-option>
            </el-select>
            <span>成本金额</span>
            <el-input v-model="item1.stockPrice" placeholder="请输入数字" style="width:1rem" class="inputDiv" size="small"></el-input>
            <currency-autocomplete :obj="item1" :styleStr="'width:0.7rem'" class="inputDiv" :sizeType="'small'"></currency-autocomplete>
            <span>报价金额</span>
            <el-input v-model="item1.ratio" placeholder="请输入数字" style="width:1rem" class="inputDiv" size="small"></el-input>
            <span>乘客人数</span>
            <el-input v-model="item1.stockNumber" placeholder="请输入数字" style="width:1rem" class="inputDiv" size="small"></el-input>
            <i v-if="index1==0" class="el-icon-circle-plus" style="font-size: 0.2rem;color: #eeaf99;" @click="addObj(item.budgetDetailList,budgetDetailObj)"></i>
            <i v-if="index1!=0" class="el-icon-remove" style="font-size: 0.2rem;color: #eeaf99;" @click="delObj(item.budgetDetailList,index1)"></i>
          </p>
          <el-input v-model="item.remark" placeholder="备注" style="width: 7.95rem;" size="small"></el-input>
        </div>      
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTraffic">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CityAutocomplete from '../../../../common/cityAutocomplete.vue'
import CurrencyAutocomplete from '../../../../common/currencyAutocomplete.vue'
import Api from '@/components/Api/index.js'
import PlanApi from '@/components/Api/PlanApi.js'
import { refresh } from '../../../js/function'
export default {
  data(){
    return{
      dialogVisible:false,
      typeObj:{},
      dataList:[],
      tafficObj:{
        trafficType:1,
      },
      xcData: {},
      trafficDetailObj:{
        flightNumber:null,
        remark:null,
        startDate:null,
        startTime:null,
        endDate:null,
        endTime:null,
        cityId:null,
        cityName:null,
        endCityId:null,
        endCityName:null,
        startPortName:null,
        endPortName:null,
        startPortList:[],
        endPortList:[],
        startFlightNo:null,
        endFlightNo:null,
        startTimeDefalut:null,
        endTimeDefalut:null,
      },
      budgetDetailObj:{
        passengerType:null,
        siteType:null,
        stockPrice:null,
        stockNumber:null,
        currency:null,
      },
      budget:{},
      passengerOption:['成人','儿童','婴儿']
    }
  },
  components:{CityAutocomplete, CurrencyAutocomplete},
  methods:{
    addObj(arr,obj){
      arr.push(JSON.parse(JSON.stringify(obj)))
    },
    delObj(arr,index){
      arr.splice(index,1)
    },
    changeTrafficType(item,type){
      if(type=='单程'){
        this.$set(item,'detailList',[JSON.parse(JSON.stringify(this.trafficDetailObj))])	
      }else if(type=='往返'){
        var obj1 = JSON.parse(JSON.stringify(this.trafficDetailObj))
        this.$set(item,'detailList',[obj1])
        var obj = JSON.parse(JSON.stringify(this.trafficDetailObj));
        obj.cityId = obj.endCityId
        obj.cityName = obj.endCityName
        obj.endCityId = obj1.cityId
        obj.endCityName=obj1.cityName
        obj.startPortName = obj.endPortName
        obj.startPortList = obj.endPortList
        obj.endPortName = obj1.startPortName
        obj.endPortList = obj1.startPortList
        item.detailList.push(obj)
      }else{
        this.$set(item,'detailList',[JSON.parse(JSON.stringify(this.trafficDetailObj))])
        item.detailList.push(JSON.parse(JSON.stringify(this.trafficDetailObj)))
      }
      this.xcData.type = type
    },
    startTimeChange(e) {
      console.log("开始时间",e)
    },
    endTimeChange(e) {
      console.log("结束时间",e)
    },
    goXc(index) {
      let data = this.dataList[index]
      console.log("datas",data)
      if (data.trafficType == 1) { //单程
        let _findStart = data.detailList[0].startPortList.find(x => x.airportNameCn ===  data.detailList[0].startPortName)
        let _endStart = data.detailList[0].endPortList.find(x => x.airportNameCn ===  data.detailList[0].endPortName)
        if (!_findStart || !_findStart.airportCode) {
           this.$message.error("请填写出发机场")
            return
        }
        if (!_endStart || !_endStart.airportCode) {
            this.$message.error("请填写抵达机场")
            return
        }
        window.open(`https://flights.ctrip.com/online/list/oneway-${_findStart.airportCode}-${_endStart.airportCode}?depdate=${data.detailList[0].startDate}&cabin=y_s_c_f&adult=1&child=0&infant=0`)
      } else if (data.trafficType == 2) { //往返
        let _findStart = data.detailList[0].startPortList.find(x => x.airportNameCn ===  data.detailList[0].startPortName)
        let _endStart = data.detailList[0].endPortList.find(x => x.airportNameCn ===  data.detailList[0].endPortName)
        if (!_findStart || !_findStart.airportCode) {
            this.$message.error("请填写出发机场")
            return
        }
        if (!_endStart || !_endStart.airportCode) {
            this.$message.error("请填写抵达机场")
            return
        }
        window.open(`https://flights.ctrip.com/online/list/round-${_findStart.airportCode}-${_endStart.airportCode}?depdate=${data.detailList[0].startDate}_${data.detailList[data.detailList.length-1].endDate}&cabin=y_s_c_f&adult=1&child=0&infant=0`)
      } else if (data.trafficType == 3) { //多程
        let code = "-"
        let times = ''
        data.detailList.forEach((item,index) => {
          let _findStart = item.startPortList.find(x => x.airportNameCn ===  item.startPortName)
          let _endStart = item.endPortList.find(x => x.airportNameCn === item.endPortName)
          if (!_findStart || !_findStart.airportCode) {
              this.$message.error("请填写出发机场")
              return
          }
          if (!_endStart || !_endStart.airportCode) {
              this.$message.error("请填写抵达机场")
              return;
          }
          if (index + 1 == data.detailList.length) {
            code = code + _findStart.airportCode + "-" + _endStart.airportCode
            times = times + item.startDate
          } else {
            code = code + _findStart.airportCode + "-" + _endStart.airportCode + "-"
            times = times + item.startDate + "_"
          }
        })
        console.log(`https://flights.ctrip.com/online/list/multi${code}?depdate=${times}&cabin=y_s&adult=1&child=0&infant=0`)
        window.open(`https://flights.ctrip.com/online/list/multi${code}?depdate=${times}&cabin=y_s&adult=1&child=0&infant=0`)
      }
    },
    addFight(item){
      item.detailList.push(JSON.parse(JSON.stringify(this.trafficDetailObj)))
    },
    changeTime(item,propName,propName1,propName2){
      var date = new Date(item[propName1])
      var arr = item[propName2].split(":")
      date.setHours(arr[0])
      date.setMinutes(arr[1])
      this.$set(item,propName,date)
    },
    getTrafficObj(){
      var obj = JSON.parse(JSON.stringify(this.tafficObj))		
      this.$set(obj,'detailList',[JSON.parse(JSON.stringify(this.trafficDetailObj))])	
      this.$set(obj,'budgetDetailList',[JSON.parse(JSON.stringify(this.budgetDetailObj))])
      return obj;
    },
    beforeOpen(typeObj){
      this.dialogVisible = true
      this.typeObj = typeObj
      this.dataList=[this.getTrafficObj()]
      if(this.trafficDetailObj.cityId){
        this.getAirPort(this.trafficDetailObj.cityId,this.dataList[0].detailList[0],'startPortList','startPortName',true)       
      }
      if(this.trafficDetailObj.endCityId){
        this.getAirPort(this.trafficDetailObj.endCityId,this.dataList[0].detailList[0],'endPortList','endPortName',true)
      }
    },
    handleSelect(item,propName,item1){
      this.$set(item1,propName=='start'?'cityId':'endCityId',item.id)
      this.$set(item1,propName=='start'?'cityName':'endCityName',item.cityNameCn)
      this.getAirPort(item.id,item1,propName+'PortList',propName+'PortName',false)
    },
    getAirPort(cityId,item,propName,propName1,flag){
      new Api('resource').airPortList({cityId:cityId,type:this.typeObj.state}).then(res => {
        if (res.status == 200) {
          this.$set(item,propName1,res.data[0].airportNameCn)
          this.$set(item,propName,res.data)
          if(flag){
            this.$set(this.trafficDetailObj,propName,res.data)
            this.$set(this.trafficDetailObj,propName1,res.data[0].airportNameCn)
          }
        }
      })
    },
    addTraffic(){
      this.dataList.forEach(e=>{
        e.trafficTool = this.typeObj.stateName
        e.budgetMainId = this.budget.id
        e.budgetDetailList.forEach(ee=>{
          ee.productName = ee.passengerType+"("+ee.siteType+")"
        })
      })
      new PlanApi('plan').addBigTraffic(this.dataList).then(res => {
        if (res.status == 200) {
          this.$message({type:"success",message:"添加成功"})
          this.dialogVisible = false
          refresh(res.data,this.budget.planId,this.budget.id)
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    }
  },
  mounted(){
    this.$Bus.$on('checkPlanObj',(data,data1)=>{
      this.budget = data1;
      this.budgetDetailObj.stockNumber = data1.useNumber
      this.trafficDetailObj.startDate = this.dateFormatYMD(data.planDate,"-")
      this.trafficDetailObj.startTimeDefalut = new Date(data.planDate)
      this.trafficDetailObj.endDate = this.dateFormatYMD(data.planDate,"-")
      if(data.cityList.length>0){
        this.trafficDetailObj.cityId = data.cityList[0].cityId
        this.trafficDetailObj.cityName = data.cityList[0].cityName
        this.trafficDetailObj.endCityId = data.cityList[0].cityId
        this.trafficDetailObj.endCityName = data.cityList[0].cityName
        if(data.cityList.length>1){
          this.trafficDetailObj.endCityId = data.cityList[1].cityId
          this.trafficDetailObj.endCityName = data.cityList[1].cityName
        }
      }
    })
  },
  beforeDestroy(){
    this.$Bus.$off("checkPlanObj");
  },
}
</script>

<style lang="scss" scoped>
.addBigTrafficDialog /deep/ .el-dialog__body{
  padding-bottom: 0.05rem !important;
}
.addBigTrafficDialog /deep/ .el-radio__label{
  font-weight: bold;
}
.addBigTrafficDialog /deep/ .el-input__inner{
  border: none;
}
.bigTrafficAdd{
  background: rgb(247, 247, 247);
  border-radius: 10px;
  span{
    font-weight: bold;
    margin-right: 0.1rem;
  }
  p{
    margin-bottom: 0.15rem;
    display: flex;
    align-items: center;
    .inputDiv{
      width:1.5rem;
      margin-right:0.1rem
    }
  }
  .infoDiv{
    padding: 0.1rem; 
    .itemNo{
      width: 0.24rem;
      height: 0.24rem;
      border-radius: 50%;
      background: #eeaf99;
      text-align: center;
      color: white;
      line-height: 0.24rem;
      margin-right: 0.12rem;
      display: inline-block;
    }
  }
  .moneyDiv{
    display: flex;
    justify-content: space-between;
    >button{
      color: #DB4E1A;
      background-color: white;
      margin-bottom: 0.05rem;
      margin-left: 0.1rem;
      border: 1px solid #DB4E1A;
      padding: 0 0.05rem;
    }
    .moneySum{
      width: 1.02rem;
      height: 0.33rem;
      text-align: center;
      background: #eeaf99;
      border-top-left-radius: 15px;
      font-size: 0.18rem;
      color: white;
      font-weight: bold;
      line-height: 0.33rem;
    }
  }
  .budgetDiv{
    border: 1px solid #EABDAD;
    padding: 0.1rem;
  }
}
</style>